<!-- This displays the device's settings as readonly for info only. -->
<template>
    <div id="device-settings"
         class="modl-tab-body">
        <div class="modl-body">
            <div class="form-h">
                <h4 class="modal__heading">
                    {{ device.name }}
                </h4>

                <div class="alert alert--small alert-info">
                    The settings for this device are displayed here for information only. The settings can be changed
                    from the Back Office.
                </div>

                <div class="form-group">
                    <label class="control-label">Auto Lock After (Minutes)</label>
                    <div class="form-group__input">
                        <input :checked="autoLockAfterMinutesValue"
                               class="form-control input-lg"
                               type="text"
                               disabled />
                    </div>
                </div>

                <div class="form-group">
                    <label class="control-label">Auto Print Receipts</label>
                    <div class="form-group__input">
                        <div class="form-group__checkbox">
                            <input :checked="device.autoPrintReceipts()"
                                   type="checkbox"
                                   disabled />
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label class="control-label">Auto Print Tickets On Sale</label>
                    <div class="form-group__input">
                        <div class="form-group__checkbox">
                            <input :checked="device.autoPrintTicketsOnSale"
                                   type="checkbox"
                                   disabled />
                        </div>
                    </div>
                </div>

                <!-- Not implemented. -->
                <!--
                <div class="form-group">
                    <label class="control-label">Auto Print Tickets On Redemption</label>
                    <div class="form-group__input">
                        <div class="form-group__checkbox">
                            <input :checked="device.autoPrintTicketsOnRedemption"
                                   type="checkbox"
                                   disabled />
                       </div>
                   </div>>
                </div>
                -->

                <div class="form-group">
                    <label class="control-label">Extended Reports</label>
                    <div class="form-group__input">
                        <div class="form-group__checkbox">
                            <input :checked="device.extendedTradingSessionSummaries"
                                   type="checkbox"
                                   disabled />
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label class="control-label">Force Orders Online</label>
                    <div class="form-group__input">
                        <div class="form-group__checkbox">
                            <input :checked="device.forceOrdersOnline"
                                   type="checkbox"
                                   disabled />
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label class="control-label">Has Souvenir Ticket Printer</label>
                    <div class="form-group__input">
                        <div class="form-group__checkbox">
                            <input :checked="device.printTickets"
                                   type="checkbox"
                                   disabled />
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label class="control-label">Manage Group Bookings</label>
                    <div class="form-group__input">
                        <div class="form-group__checkbox">
                            <input :checked="device.manageGroupBookings"
                                   type="checkbox"
                                   disabled />
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label class="control-label">Payment Terminal Has Printer</label>
                    <div class="form-group__input">
                        <div class="form-group__checkbox">
                            <input :checked="device.terminalHasPrinter"
                                   type="checkbox"
                                   disabled />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modl-footer">
            <!-- Cancel button -->
            <button class="btn btn-lg btn-default cancel-btn"
                    @click.prevent="$emit('cancel')">
                {{ l('CANCEL') }}
            </button>
        </div>
    </div>
</template>

<script>
import { container } from '@/container';

export default {
    emits: [
        'cancel',
    ],

    data() {
        return {
            device: null,
        };
    },

    computed: {
        autoLockAfterMinutesValue() {
            if (this.device && this.device.autoLockAfterMinutes) {
                return this.device.autoLockAfterMinutes;
            }

            return 'Never';
        },
    },

    created() {
        this.device = container.currentDevice.device;
    },
};
</script>
